import template from './has-investment-project.jade';
import itemsHasNo from '../../../enums/has-no';

export default angular
    .module('cian.addForm.hasInvestmentProject', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutObjectHasInvestmentProject', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = itemsHasNo;
        },
        controllerAs: 'hasInvestmentProject',
        template,
    }))
    .name;
